import { DatePipe } from '@angular/common';
import localeTh from '@angular/common/locales/th';

export function getCurrentDateFormatted(format: string = 'yyyy-MM-dd'): string  {
  const currentDate = new Date();
  return new DatePipe('en-US').transform(currentDate, format) ?? '';
}

export function getDateFormatted(date: string, format: string = 'yyyy-MM-dd HH:mm'): string  {
  const converted_date = new Date(date);
  return new DatePipe('en-US').transform(converted_date, format) ?? '';
}

export function getTimeFromDateTimeString(dateTime: string): string  {
  const currentDate = new Date(dateTime);
  // return new DatePipe(getLocalTimeZone()).transform(currentDate, 'HH:mm') ?? '';
  return new DatePipe('en-US').transform(currentDate, 'HH:mm') ?? '';
}

export function getLocalTimeZone(): string {
  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  console.log(`getLocalTimeZone, timeZone: ${timeZone}`);
  return timeZone;
}

export function convertToLocalTimeToUTC(localTime: string): string {
  // Parse the local time string to create a Date object
  const localDate = new Date(localTime);

  // Get the UTC time in ISO format
  const utcTime = localDate.toISOString();

  return utcTime;
}

export function convertUTCToLocal(utcTime: string): string {
  // Parse the UTC time string to create a Date object
  const utcDate = new Date(utcTime);

  // Get the local time in ISO format
  const localTime = utcDate.toLocaleString();

  return localTime;
}
